import { TableCell, TableHead, TableRow } from "@mui/material";
import { Theme, SxProps } from "@mui/material/styles";
import { IHeadLabel } from "../../types/table";

type Props = {
    headLabel: IHeadLabel[];    
    sx?: SxProps<Theme>;
};

const TableHeadComponent = ({ headLabel, sx } : Props) => {

    return (
        <TableHead sx={sx}>
            <TableRow>
                {
                    headLabel.map((headCell: IHeadLabel, index: number) => (
                        <TableCell
                            key={index}
                            align={headCell.align || 'left'}
                            sx={{ width: headCell.width, minWidth: headCell.minWidth }}
                        >
                            {headCell.label}
                        </TableCell>
                    ))
                }
            </TableRow>
        </TableHead>
    );

}

export default TableHeadComponent;